import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const PrivacyPolicy: React.FC = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Privacy Policy</h1>
      <p className="legal-updated">Last updated: August 26, 2026</p>

      <p>
        This policy explains what personal data PHI Printing collects, why we
        collect it, and the rights you have over it. It applies to
        phiprinting.com and covers customers, guest shoppers, and artist
        members worldwide, including rights under the GDPR (EU/UK) and the
        CCPA/CPRA (California).
      </p>

      <h2>1. What we collect</h2>
      <ul>
        <li>
          <strong>Account data</strong> — email, name, and a hashed password
          (we never store your password in plain text).
        </li>
        <li>
          <strong>Order data</strong> — items purchased, shipping address,
          order history, and return requests. Payment card details are handled
          entirely by Square or PayPal; we never see or store card numbers.
        </li>
        <li>
          <strong>Uploaded images</strong> — photos you upload for printing and
          artwork uploaded by artist members, stored only to fulfill orders and
          operate the marketplace.
        </li>
        <li>
          <strong>Artist member data</strong> — application details, bio,
          social links, and payout handle for approved artists.
        </li>
        <li>
          <strong>Technical data</strong> — standard server logs (IP address,
          request time) kept for security and abuse prevention.
        </li>
      </ul>

      <h2>2. Why we collect it (legal bases)</h2>
      <ul>
        <li>To fulfill your orders and provide the service (contract)</li>
        <li>To keep records of transactions (legal obligation, e.g. tax law)</li>
        <li>To secure the site and prevent fraud (legitimate interest)</li>
        <li>To send order emails — confirmations, shipping, returns (contract)</li>
      </ul>
      <p>
        We do not sell your personal data, and we do not use it for third-party
        advertising. We do not send marketing email.
      </p>

      <h2>3. Who we share it with</h2>
      <ul>
        <li><strong>Payment processors</strong> — Square and PayPal, to process payments</li>
        <li><strong>Shipping carriers</strong> — name and address, to deliver orders</li>
        <li><strong>Hosting providers</strong> — servers that run the site and store uploads</li>
      </ul>
      <p>We never share uploaded photos with anyone except as needed to print and ship your order.</p>

      <h2>4. How long we keep it</h2>
      <ul>
        <li>Account data — until you delete your account</li>
        <li>Order records — retained as required for tax and accounting law</li>
        <li>Uploaded print images — retained to support reprints and returns; removed on request</li>
        <li>Guest session data — stored in your browser; clears when you clear site data</li>
      </ul>

      <h2>5. Your rights</h2>
      <p>Depending on where you live, you have the right to:</p>
      <ul>
        <li><strong>Access / portability</strong> — download a copy of your data from your Profile page</li>
        <li><strong>Correction</strong> — update your name and details in your Profile</li>
        <li>
          <strong>Erasure</strong> — delete your account from your Profile page.
          This permanently removes your personal details, addresses, and saved
          payment references; order records are retained without a usable
          identity, as required by tax and accounting law.
        </li>
        <li><strong>Complaint</strong> — lodge a complaint with your local data protection authority</li>
      </ul>
      <p>
        To exercise any right you can't complete from your Profile page, email{' '}
        <a href="mailto:privacy@phiprinting.com">privacy@phiprinting.com</a>. We
        respond within 30 days.
      </p>

      <h2>6. Cookies and local storage</h2>
      <p>
        We use only functional storage — sign-in tokens, your cart session, and
        (with your consent) your theme preference. We use no analytics or
        advertising cookies. See the <Link to="/cookies">Cookie Policy</Link>{' '}
        for the full list.
      </p>

      <h2>7. Children</h2>
      <p>
        The site is not directed at children under 16 and we do not knowingly
        collect their data.
      </p>

      <h2>8. Contact</h2>
      <p>
        Privacy questions: <a href="mailto:privacy@phiprinting.com">privacy@phiprinting.com</a>.
      </p>
    </div>
  </div>
);

export default PrivacyPolicy;
